import { createContext, useContext, useEffect, useState } from "react";

/**
 * Shares the horizontal collapse (icon-rail) state between the Sidebar and the
 * header hamburger toggle, which live in different parts of the tree.
 * Persisted across reloads.
 */
const SidebarContext = createContext(null);

export const SidebarProvider = ({ children }) => {
	const [collapsed, setCollapsed] = useState(
		() => localStorage.getItem("sidebarCollapsed") === "true"
	);

	useEffect(() => {
		localStorage.setItem("sidebarCollapsed", String(collapsed));
	}, [collapsed]);

	const toggleCollapsed = () => setCollapsed((c) => !c);

	return (
		<SidebarContext.Provider value={{ collapsed, toggleCollapsed }}>
			{children}
		</SidebarContext.Provider>
	);
};

// Falls back to a no-op when used outside a provider so consumers never crash.
export const useSidebar = () =>
	useContext(SidebarContext) || { collapsed: false, toggleCollapsed: () => {} };
